var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.285 9H17.715C12.255 9 9 12.255 9 17.715V30.27C9 35.745 12.255 39 17.715 39H30.27C35.73 39 38.985 35.745 38.985 30.285V17.715C39 12.255 35.745 9 30.285 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.625 20.625H18.375C17.76 20.625 17.25 20.115 17.25 19.5C17.25 18.885 17.76 18.375 18.375 18.375H29.625C30.24 18.375 30.75 18.885 30.75 19.5C30.75 20.115 30.24 20.625 29.625 20.625Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.625 29.625H18.375C17.76 29.625 17.25 29.115 17.25 28.5C17.25 27.885 17.76 27.375 18.375 27.375H29.625C30.24 27.375 30.75 27.885 30.75 28.5C30.75 29.115 30.24 29.625 29.625 29.625Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSquare);
export default __webpack_public_path__ + "static/media/documentSquare.b92be547ce9ddccdef67b5600656c118.svg";
export { ForwardRef as ReactComponent };